import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  // MESP Navy + Gold identity (Jun 2026).
  // Toasts adopt the brand palette directly: deep navy surface, white
  // text, gold accent for the primary action. Position is top-center
  // because Arabic readers default to scanning the top of the viewport
  // first, and our preview testing showed bottom-anchored toasts
  // collide with the VoiceRoom control bar on mobile.
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="top-center"
      richColors={false}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#121A33] group-[.toaster]:text-white group-[.toaster]:border group-[.toaster]:border-[#1E2A4A] group-[.toaster]:shadow-xl group-[.toaster]:backdrop-blur",
          title: "group-[.toast]:text-white group-[.toast]:font-semibold",
          description: "group-[.toast]:text-[#A0AABF]",
          actionButton:
            "group-[.toast]:bg-[#C9A24E] group-[.toast]:text-[#0A1128] group-[.toast]:font-semibold group-[.toast]:hover:bg-[#B5901C]",
          cancelButton:
            "group-[.toast]:bg-transparent group-[.toast]:text-[#A0AABF] group-[.toast]:border group-[.toast]:border-[#1E2A4A]",
          success:
            "group-[.toaster]:!border-[rgba(16,185,129,0.4)]",
          error:
            "group-[.toaster]:!border-[rgba(239,68,68,0.4)]",
          warning:
            "group-[.toaster]:!border-[rgba(245,158,11,0.4)]",
          info:
            "group-[.toaster]:!border-[rgba(59,130,246,0.4)]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
